module.exports = __webpack_public_path__ + "static/media/screen.051b57ec.svg";